import React from 'react';
import classNames from 'classnames';
import { isIOS, isAndroidChrome } from '../../../helpers/serverRenderingUtils';
import {
  AppStoreButton,
  PlayStoreButton,
} from '../../components/AppDownloadButtons';
import Box from '../../shared/Box';
import Image from '../../shared/Image';
import styles from './styles.sass';
import { PublicWebsiteNavContainer } from '../../components/PublicWebsiteNav/PublicWebsiteNavContainer';
import { NavbarWithoutMenu } from './components/NavbarWithoutMenu';

const ASSET_CDN =
  'https://d12xoj7p9moygp.cloudfront.net/images/screens/beonspotify/';

function AppStoreDownloadButton() {
  if (isAndroidChrome()) return <PlayStoreButton width={181} />;
  if (isIOS()) return <AppStoreButton width={181} />;
  return <AppStoreButton width={181} />;
}

function QuicksilverAppPage(props) {
  return (
    <Box className={styles.quicksilverLandingPage} smMaxWidth={480}>
      <NavbarWithoutMenu />
      <Box
        width="100%"
        display="flex"
        justifyContent="center"
        color="#4100F5"
        className={styles.hero}
        minHeight={800}
      >
        <Box
          width="100%"
          paddingBottom={40}
          mdPaddingLeft={30}
          mdPaddingRight={30}
          smPaddingLeft={15}
          smPaddingRight={15}
        >
          <h1 className={classNames(styles.title, styles.white, styles.center)}>
            Make your own podcast.
          </h1>
          <p
            className={classNames(
              styles.subheader,
              styles.white,
              styles.center
            )}
          >
            Now it's easy to get heard on Spotify with our new podcast creation
            app, Anchor.
          </p>
          <div
            className={classNames(
              styles.imageContainer,
              styles.heroImageContainer
            )}
          >
            <Image
              imageUrl={`${ASSET_CDN}header.png`}
              retinaImageUrl={`${ASSET_CDN}header@2x.png`}
            />
          </div>
          <Box display="flex" justifyContent="center">
            <AppStoreDownloadButton />
          </Box>
        </Box>
      </Box>
      <Box color="#fff" className={styles.valueProps}>
        <Box
          color="#fff"
          display="flex"
          justifyContent="center"
          className={styles.valueProp}
        >
          <div className={styles.imageContainer}>
            <Image
              imageUrl={`${ASSET_CDN}anchor.png`}
              retinaImageUrl={`${ASSET_CDN}anchor@2x.png`}
            />
          </div>
          <div className={styles.copy}>
            <h2 className={styles.title}>A match made in podcast heaven</h2>
            <p className={styles.subheader}>
              We recently welcomed Anchor to the Spotify family to make it
              easier for anyone to create a podcast.
            </p>
          </div>
        </Box>
        <Box
          color="#fff"
          display="flex"
          justifyContent="center"
          className={styles.valueProp}
        >
          <div className={styles.copy}>
            <h2 className={styles.title}>Do it all, right from your phone</h2>
            <p className={styles.subheader}>
              The Anchor app features free high-quality creation tools like
              recording, editing, background music, and voice messaging.
            </p>
          </div>
          <div className={styles.imageContainer}>
            <Image
              imageUrl={`${ASSET_CDN}spotify-create.png`}
              retinaImageUrl={`${ASSET_CDN}spotify-create@2x.png`}
            />
          </div>
        </Box>
        <Box
          color="#fff"
          display="flex"
          justifyContent="center"
          className={styles.valueProp}
        >
          <div className={styles.imageContainer}>
            <Image
              imageUrl={`${ASSET_CDN}spotify.png`}
              retinaImageUrl={`${ASSET_CDN}spotify@2x.png`}
            />
          </div>
          <div className={styles.copy}>
            <h2 className={styles.title}>Get heard on Spotify</h2>
            <p className={styles.subheader}>
              With just one tap, your show will be available on Spotify, Apple
              Podcasts, Google Podcasts, and most listening platforms.
            </p>
            <p className={styles.subheader}>
              We can't wait to hear your podcast.
            </p>
          </div>
        </Box>
      </Box>
    </Box>
  );
}

export default QuicksilverAppPage;
